import React from 'react';
import { Form, Input, Select, Checkbox, Button } from 'antd';

const { Option } = Select;
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const MachineForm = ({ form, users = [], countries = [], onFinish }) => {
  return (
    <Form form={form} {...layout} onFinish={onFinish}>
      <Form.Item
        label="Machine Name"
        name="machinename"
        rules={[{ required: true, message: 'Please input the machine name!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Machine ID"
        name="machineid"
        rules={[{ required: true, message: 'Please input the machine ID!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item label="User" name="user">
        <Select allowClear>
        <Option value={null}>None</Option> {/* Use null to represent 'None' */}
          {users.map(user => (
            <Option key={user._id} value={user._id}>{user.username}</Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="Country"
        name="country"
        rules={[{ required: true, message: 'Please select a country!' }]}
      >
        <Select allowClear placeholder="Select country">
          {countries.map(country => (
            <Option key={country._id} value={country._id}>{country.name}</Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="Linked PC"
        name="islinkedPC"
        valuePropName="checked"
      >
        <Checkbox />
      </Form.Item>
      <Form.Item
        label="ID PC"
        name="idpc"
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Key PC"
        name="keypc"
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Status"
        name="isActive"
        valuePropName="checked"
      >
        <Checkbox>Active</Checkbox>
      </Form.Item>
     
    </Form>
  );
};

export default MachineForm;
